// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"be7fb1dd","283":"a699e6a7","506":"d9d2d59e"}[chunkId] + ".chunk.css";
};